/*
 * @Author: Tahiti
 * @Date: 2025-10-24
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-24 18:15:09
 * @Description: 图片工具相关API接口
 * @FilePath: /weryai-web/api/image-tools.ts
 */
import { http } from '~/utils/request'

// ========== 图片文字翻译相关接口 ==========

/**
 * @description 图片文字翻译
 * @param data 翻译参数
 */
export const imageTextTranslateApi = (data: {
    img_url: string
    target_lang: string
    type: 'text' | 'image'
    team_id?: string
    platform?: string
    request_id?: string
}) => {
    return http.post('/api/v1/auth/creative/img/translate', data)
}

// ========== 图片比例转化相关接口 ==========

/**
 * @description 图片比例转化
 * @param data 转化参数
 */
export const imageAspectRatioConverterApi = (data: {
    image_url: string
    aspect_ratio: string
    platform?: string
    p?: string
    t?: number
    team_id?: string
    type?: string
}) => {
    return http.post('/api/v1/auth/creative/img/reframe', data)
}

/**
 * @description 图片清晰度增强
 * @param data 放大参数
 */
export const imageUpscalerApi = (data: {
    image_url: string
    team_id?: string
    platform?: string
    request_id?: string
    public_visible?: boolean
    copyright_protection?: boolean
    p?: string
    type?: string
}) => {
    return http.post('/api/v1/auth/creative/img/upscale', data)
}

// ========== 通用任务相关接口 ==========

/**
 * @description 获取任务结果
 * @param taskId 任务ID
 */
export const getTaskResultApi = (taskId: string) => {
    return http.get(`/backend/auth/task/${taskId}`)
}

/**
 * @description 获取任务详情
 * @param id 日志ID
 */
export const getTaskResultDetailApi = (id: string | number) => {
    return http.get(`/backend/auth/ad-creative-log/${id}`)
}

/**
 * @description 上报任务结果
 * @param data 上报数据
 */
export const reportTaskResultApi = (data: {
    task_id: string
    creative_id: string | number
}) => {
    return http.post('/backend/auth/task/display-report', data)
}

/**
 * @description 取消任务
 * @param taskId 任务ID
 */
export const cancelTaskApi = (taskId: string) => {
    return http.post(`/backend/auth/task/cancel/${taskId}`, {})
}

/**
 * @description 图片换脸
 * @param data 换脸参数
 */
export const photoFaceSwapApi = (data: {
    face_img_url: string
    img_url: string
    team_id?: string
    platform?: string
    request_id?: string
    copyright_protection?: boolean
    public_visible?: boolean
    product_id?: number
    type?: string
}) => {
    return http.post('/api/v1/auth/creative/img/face_swap', data)
}

/**
 * @description 照片修复
 * @param data 修复参数
 */
export const photoRestorationApi = (data: {
    img_url: string
    team_id?: string
    platform?: string
    request_id?: string
    copyright_protection?: boolean
    public_visible?: boolean
    product_id?: number
    model?: string
    type?: string
}) => {
    return http.post('/api/v1/auth/creative/img/img_repair', data)
}

/**
 * @description: 图片背景移除
 * @return {*}
 */
export const imgBackgroundRemoveApi = (data: {
    img_url: string
    team_id?: string
    platform?: string
    request_id?: string
    copyright_protection?: boolean
    public_visible?: boolean
    product_id?: number
    type?: string
}) => {
    return http.post('/api/v1/auth/creative/img/img_bg_remove', data)
}

/**
 * @description: 图片反推提示词
 * @return {*}
 */
export const imagePromptReversalApi = (data: {
    image_url: string
    copyright_protection?: boolean
    public_visible?: boolean
    language?: string
    image_size?: number
}) => {
    return http.post('/api/v1/auth/creative/img/prompt/from_image', data)
}

/**
 * @description: 图片扩图
 * @return {*}
 */
export const imageExtenderApi = (data: {
    canvas_size: string
    copyright_protection: boolean
    image_url: string
    original_image_location: string
    original_image_size: string
    public_visible: boolean
    type?: string
}) => {
    return http.post('/api/v1/auth/creative/img/image/expand', data)
}
